import { DatePicker } from '@mui/x-date-pickers-pro';
import type { DatePickerProps } from '@mui/x-date-pickers-pro';
import { exists } from 'i18next';
import { useTranslation } from 'react-i18next';

import { useFieldContext } from '@/forms/formContext';
import { BaseInputFieldProps } from '@/forms/types';

type DateInputFieldProps = Omit<
  BaseInputFieldProps,
  'placeholder' | 'showIsValid'
> &
  Omit<DatePickerProps, 'value' | 'onChange' | 'name' | 'label'>;

export const DateInputField = ({
  required,
  label,
  ...props
}: DateInputFieldProps) => {
  const field = useFieldContext();
  const { t } = useTranslation('forms');

  const isError = !!(
    (!field.state.meta.isValid && field.state.meta.isDirty) ||
    (!field.state.meta.isValid && field.form.state.submissionAttempts > 0)
  );

  const displayError = isError ? field.state.meta.errors[0] : null;
  const translatedError = displayError
    ? exists(displayError?.message, {
        ns: 'forms',
      })
      ? t(displayError.message)
      : displayError.message
    : null;

  return (
    <DatePicker
      {...props}
      name={field.name}
      label={label}
      value={field.state.value as Date | null}
      onChange={(newValue) => field.handleChange(newValue)}
      slotProps={{
        textField: {
          helperText: isError && displayError ? translatedError : null,
          error: isError,
          // placeholder: placeholder,
          required: required,
        },
        field: {
          id: field.name,
        },
      }}
    />
  );
};
